export const translates = {
    appTitle: "Fit-K.O. notes",

    // InfiniteSelector
    selectorSearch: "Hledat",
    selectorAllCategories: "Vše",
    selectorAllLetters: "Vše",
    selectorNoResults: "Žádné výsledky",


    // Sign/Auth - Action Titles
    signStartLoginInfo: "Pokud jsi už zaregistrovaný a znáš své heslo použij",
    signStartLogin: "Přihlásit se",
    signStartRegisterOrResetInfo: "Pokud nejsi zaregistrovaný nebo neznáš své heslo použij",
    signStartRegisterOrReset: "Registrovat nebo obnovit heslo",

    signActionRegisterOrRecovery: "Registrovat nebo obnovit heslo",
    signActionPasswordRecovery: "Obnova hesla",
    signActionCreateAccount: "Registrace",
    signActionLogged: "Přihlášeno",
    signActionLogin: "Přihlášení",
    signActionNewPassword: "Nastavení nového hesla",
    signActionStart: "Vítej v aplikaci",
    signActionStartInfo: "Ahoj! Chceš mít lepší výsledky a potřebuješ vedení na své cestě za zdravějším životním stylem? Se mnou to zvládneš! Jako první je potřeba abys byl přihlášený. Zabere to jen chviku",

    // Sign/Auth - Buttons
    signButtonLogin: "Přihlásit",
    signButtonLogout: "Odhlásit",
    signButtonGoToApp: "Přejít do aplikace",
    signButtonCreateAccount: "Vytvořit účet",
    signButtonSetPassword: "Nastavit heslo",
    signButtonResetPassword: "Obnovit heslo",
    signButtonRegisterOrReset: "Registrovat / Obnovit heslo",

    // Sign/Auth - Form Labels
    signLabelEmail: "Email",
    signLabelPassword: "Heslo",
    signLabelPasswordAgain: "Heslo znovu",
    signLabelName: "Jméno",
    signLabelShowPassword: "Zobrazit heslo",
    signLabelAgreeWith: "Souhlasím s ",
    signLabelTermsOfService: "podmínkami služby",
    signLabelSetTrainerAs: "Nastavit",
    signLabelAsMyTrainer: "jako mého trenéra. (Toto nastavní můžeš později změnit)",

    // Sign/Auth - Status Messages
    signStatusLoggedInAs: "Jsi přihlášen(a) jako:",
    signStatusRegistration: "Registrace",
    signStatusForgotPassword: "Zapomenuté heslo",

    // Sign/Auth - Validation Errors
    signErrorEnterName: "Zadej jméno",
    signErrorMustAgreeToTerms: "Je potřeba souhlasit s podmínkami",
    signErrorEnterPassword: "Zadej heslo",
    signErrorEnterEmail: "Zadej email",
    signErrorInvalidCredentials: "Chybně zadaný email nebo heslo.",
    signErrorPasswordMismatch: "Hesla se neshodují",
    signErrorPasswordTooWeak: "Heslo je moc jednoduché",

    // Sign/Auth - Success Messages
    signSuccessRegistrationComplete: "Registrace byla dokončena, můžeš se přihlásit",
    signSuccessPasswordChanged: "Heslo bylo změněno",
    signSuccessEmailSent: "Odesláno, zkontroluj svůj email {email} a pokračuj podle instrukcí.",

    // Sign/Auth - Error Messages
    signErrorRegistrationFailed: "Nepodařilo se dokončit registraci z důvodu: ",
    signErrorPasswordChangeFailed: "Nepodařilo se změnit heslo z důvodu: ",
    signErrorRequestFailed: "Nepodařilo se odeslat požadavek, zkus to znovu.",

    clientDataBannerInfo: 'Nemáš zadány své údaje. Tyto údaje potřebuji pro výpočet doporučených hodnot. Chceš zadat ted?',
    clientDataBannerYesEntry: 'Ano, zadat ted',

    // Generic messages
    genYes: 'Ano',
    genLater: 'Později',
    genSave: 'Uložit',
    genCancel: 'Storno',
    genLoading: '... načítám další položky ...',

    // Visual settings
    visualThemeLabel: 'Barevné schéma',
    visualFontSizeLabel: 'Velikost písma',
    visualThemeAuto: 'Automaticky',
    visualThemeDark: 'Tmavé',
    visualThemeLight: 'Světlé',
    visualSettingsSaved: 'Nastavení vzhledu uloženo',

    nutriInfoCopied: 'Zkopírováno do schránky',
    nutriInfoCopyFailed: 'Kopírování se nezdařilo',
    nutriInfoFoodTitle: 'Jídlo',
    nutriInfoActivityTitle: 'Aktivity',
    nutriInfoMeasureTitle: 'Měření',

    // Font size labels
    fontSizeMin: 'Malé',
    fontSizeNormal: 'Normální',
    fontSizeMax: 'Velké',

    proteinContent: 'Proteiny',
    carbohydrateContent: 'Sacharidy',
    fatContent: 'Tuky',
    fatSatContent: 'Nasycený tuk',
    fatUnsatContent: 'Nenasycený tuk',
    energy: 'Energie',

    // Client data panel
    clientDataTitle: 'Moje údaje',
    clientDataSectionBasic: 'Základní údaje',
    clientDataLabelGender: 'Pohlaví',
    clientDataLabelDtBirth: 'Datum narození',
    clientDataLabelHeight: 'Výška (cm)',
    clientDataLabelMass: 'Hmotnost (kg)',
    clientDataLabelPalLevelWork: 'Pracovní aktivita',
    clientDataLabelPalLevelSport: 'Sportovní aktivita',
    clientDataLabelProfile: 'Profil',
    clientDataLabelEnergyUnit: 'Jednotka energie',
    clientDataSectionEnergy: 'Příjem energie',
    clientDataLabelBasalEnergy: 'Bazální energie',
    clientDataLabelRecEnergy: 'Doporučený příjem energie',
    clientDataAutomatic: 'Automaticky',
    clientDataSectionFoodDistribution: 'Rozdělení složek jídla',
    clientDataSectionDayPlan: 'Rozložení jídla v průběhu dne',
    clientDataLabelTimezone: 'Časová zona',
    clientDataSavedOk: 'Data uloženy',
    clientDataSavedError: 'Nejprve oprav chyby',

    proteinPerMass: 'Proteiny',
    fatSatPerMassActive: 'Nasycený tuk při odpočinku',
    fatUnsatPerMassActive: 'Nenasycený tuk při odpočinku',
    fatSatPerMassTraining: 'Nasycený tuk při tréninku',
    fatUnsatPerMassTraining: 'Nenasycený tuk při tréninku',
    activeDayBurnedEnergy: 'Minimální tréninková energie',
    trainingDayBurnedEnergy: 'Běžná tréninková energie',
};